import React, { Fragment } from "react";
import { Link } from "react-router-dom";
var truncate = require("truncate");
const BlogCard = (props) => {
  return (
    <Fragment>
      <div
        className="card h-100"
        style={{ direction: "rtl", textAlign: "right" }}
      >
        <Link to={`/${props.detailsUrl}/${props.item.id}`}>
          <img
            src="/images/company2.jpg"
            className="card-img-top rounded"
            alt="..."
          />
        </Link>

        <div className="align-items-stretch card-body d-flex flex-column justify-content-between">
          <h6 className="card-title fw-bold">
            <Link
              to={`/${props.detailsUrl}/${props.item.id}`}
              className="text-dark"
            >
              {truncate(props.item.title, 70)}
            </Link>
          </h6>
          <p className="card-text text-dark">
            {truncate(props.item.long_text, 150)}
          </p>
          <hr />
          <div className="d-flex justify-content-between  text-muted">
            <small>
              <i className="fa fa-user me-2"></i>
              <span> {props.item.author}</span>
            </small>
            <small> {props.item.created_at}</small>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BlogCard;
